import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomFacade, noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { cloneDeep } from 'lodash';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { GridCellDropdownComponent } from '../grid-cell-dropdown/grid-cell-dropdown.component';
import { setDelayedFlag } from 'libs/shared/src/lib/service/helper.service';
import { GridCellRendererComponent } from '../grid-cell-renderer/grid-cell-renderer.component';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { SharedService } from '../../../../data/src/lib/services/shared/shared.service';
import { CookieService } from 'ngx-cookie-service';
import { CustomReuseDataGridService } from '@piqet-angular/features';
@Component({
  selector: 'piqet-angular-new-custom-reuse',
  templateUrl: './new-custom-reuse.component.html',
  styleUrls: ['./new-custom-reuse.component.scss'],
})
export class NewCustomReuseComponent implements OnDestroy {
  @Output() saveCustomReuseEvent = new EventEmitter<{ payload: any; pathName: any }>();

  customReuseForm!: FormGroup;
  submitted = false;
  energyItems: any;
  reuseProcessForm: any;
  processSubmitted = false;
  isReadonly = true;
  processColumnDef: any;
  modalLabel: any;
  customReuseData: any;
  reuseTypeId: any;
  ingredientId: any;
  customReuseId = 0;
  ingredientIndex: any;
  headerBtn = 'Add row';
  headerBtnName = 'customReuse';
  disableSubmit = false;
  isRowEditable = false;
  activatedRoute: any;
  selectOrganization: any;
  organizationlist: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  selectedDropDownValue: any;
  setOrganizationValue: any;
  fromEdit: any;
  gridLoaded = { value: false };
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    dropdownRendered: GridCellDropdownComponent,
    GridCellRendererComponent: GridCellRendererComponent,
  };
  showEdit: boolean = false;
  showCreate: boolean = false;
  showView: boolean = false;
  checkEntireAccess: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public customFacade: CustomFacade,
    private customService: CustomService,
    private modal: CustomModalService,
    private swalService: SwalService,
    private sharedService: SharedService,
    private cookieService: CookieService,
    private customReuseDataGridService: CustomReuseDataGridService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.processColumnDef = this.modal?.modalService?.config?.initialState?.['processColDef'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.fromEdit = this.modal?.modalService?.config?.initialState?.['fromEdit'];
    this.customReuseData = this.modal?.modalService?.config?.initialState?.['newCustomReuseData'];
    this.isDisabledDropDown = this.modalLabel == 'Review custom reuse' ? true : false;
    this.isHideDropDown = this.activatedRoute == 'adminCustomReuse' ? true : false;

    this.customFacade.reuseData$.subscribe((res: any) => {
      this.customReuseData =
        (res.hasOwnProperty('length') && res.length) || (res && res.id) || !this.fromEdit
          ? res
          : this.customReuseData;
      this.initializeData();
    });
  }

  ngOnInit(): void {
    this.showEdit = this.customReuseDataGridService.isAccess(this.activatedRoute, 'edit');
    this.showCreate = this.customReuseDataGridService.isAccess(this.activatedRoute, 'create');
    this.showView = this.customReuseDataGridService.isAccess(this.activatedRoute, 'view');
    this.checkEntireAccess =
      (this.showCreate && !this.fromEdit) ||
      (this.fromEdit && this.showEdit) ||
      (this.fromEdit && !this.showView);
  }

  initializeData() {
    const newProcesslist = this.customReuseData.energyItems;
    this.customFacade.customReuseEnergyItems$.subscribe((response: any) => {
      this.energyItems = response;
      this.processColumnDef = cloneDeep(this.processColumnDef);
      this.processColumnDef[0].cellEditorParams['reuseIngredientList'] = this.energyItems;
    });

    this.organizationlist = this.customReuseData.organizationList;
    this.organizatioListFunction();
    this.customReuseId = this.customReuseData.id;
    this.customReuseForm = this.formBuilder.group({
      reuseName: [
        this.customReuseData.processName || '',
        [Validators.required, noWhitespaceValidator],
      ],
      organizationName: [null, Validators.required],
      reuseProcessForm: this.formBuilder.group({
        process: [null, Validators.required],
        amount: [null, Validators.required],
        cost: [0, [Validators.min(0)]],
        packageCost: [0, Validators.min(0)],
      }),
    });
    this.setFormData();
    this.selectedDropDownValue = this.selectOrganization;
    this.setOrganizationValue = this.selectOrganization;
    this.customFacade.copiedReuseIngredient$.subscribe((ingredient: any) => {
      if (ingredient) {
        this.ingredientIndex = ingredient?.index;
        this.ingredientId = ingredient?.id;
        this.reuseTypeId = ingredient?.energyProcessId;
        this.customReuseForm.get('reuseProcessForm')?.patchValue({
          process: ingredient.energyProcessName,
          amount: ingredient.amount,
          cost: ingredient.cost,
          packageCost: ingredient.packageCost,
        });
      }
    });
    this.customFacade.customReuseError$.subscribe((error: any) => {
      this.checkValidation(error);
    });

    this.sharedService.disableAddRowBtnTrigger$.subscribe((error: any) => {
      this.checkEditingStatus(error);
    });

    setDelayedFlag(this.gridLoaded, true, 200);
  }

  alertConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Are you sure you want to change the organization? if you are change the organization than energy process data will be lost.',
        'organization'
      )
      .then(confirmed => {
        if (confirmed) {
          this.setOrganizationValue = data;
          this.selectedDropDownValue = data;
        } else {
          this.setOrganizationValue = this.selectedDropDownValue;
        }
      });
  }

  selectValue(event: any) {
    if (event.name) {
      this.alertConfirmation(event);
    }
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.customReuseData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  setFormData() {
    this.customReuseForm.patchValue({ organizationName: this.selectOrganization });
  }
  onClose() {
    this.modal.close();
    // this.customFacade.clearReuseIngredient();
  }

  restrictE(event: any) {
    if (event.key === 'e' || event.key === 'E' || event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().startsWith(term.toLowerCase());
  }

  manufactureCost() {
    const amount = this.customReuseForm.controls['reuseProcessForm'].value.amount;
    const cost = this.customReuseForm.controls['reuseProcessForm'].value.cost;
    this.customService.GetPackageCostCalculationCustomReuse(amount, cost).subscribe((data: any) => {
      this.customReuseForm.controls['reuseProcessForm'].get('packageCost')?.patchValue(data.data);
    });
  }

  editFillingProcess() {
    this.processSubmitted = true;
    if (
      this.customReuseForm.value.reuseProcessForm.process.name == '-- Select process -- ' &&
      this.reuseProcessForm.controls['process'].valid
    ) {
      this.reuseProcessForm.get('process')?.reset();
      this.processSubmitted = true;
      this.reuseProcessForm.controls['process'].markAsTouched();
      return;
    }
    if (this.customReuseForm.value.reuseProcessForm.amount) {
      const processData = {
        energyProcessName:
          this.customReuseForm.value.reuseProcessForm.process.name ||
          this.customReuseForm.value.reuseProcessForm.process,
        amount: this.customReuseForm.value.reuseProcessForm.amount,
        cost: this.customReuseForm.value.reuseProcessForm.cost,
        packageCost: this.customReuseForm.value.reuseProcessForm.packageCost,
        energyProcessId: this.customReuseForm.value.reuseProcessForm.process.id || this.reuseTypeId,
        id: 0,
        customReuseId: this.customReuseId,
      };
      this.processSubmitted = false;
      this.customFacade.updateReuseIngredientAction(
        processData,
        'editIngredient',
        this.ingredientIndex
      );
      this.customReuseForm.controls['reuseProcessForm'].reset();
    }
  }

  addFillingProcess() {
    this.processSubmitted = true;
    if (
      this.customReuseForm.value.reuseProcessForm.process.name == '-- Select process -- ' &&
      this.reuseProcessForm.controls['process'].valid
    ) {
      this.reuseProcessForm.get('process')?.reset();
      this.processSubmitted = true;
      this.reuseProcessForm.controls['process'].markAsTouched();
      return;
    }
    if (this.customReuseForm.value.reuseProcessForm.amount) {
      const processData = {
        id: 0,
        energyProcessName:
          this.customReuseForm.value.reuseProcessForm.process.name ||
          this.customReuseForm.value.reuseProcessForm.process,
        amount: this.customReuseForm.value.reuseProcessForm.amount,
        cost: this.customReuseForm.value.reuseProcessForm.cost,
        packageCost: this.customReuseForm.value.reuseProcessForm.packageCost,
        energyProcessId: this.customReuseForm.value.reuseProcessForm.process.id || this.reuseTypeId,
        customReuseId: this.customReuseId,
      };
      this.processSubmitted = false;
      this.customFacade.addReuseIngredientAction(processData, 'add');
      this.customReuseForm.controls['reuseProcessForm'].reset();
    }
  }

  checkValidation(reuseIngredientError: any): void {
    this.disableSubmit = !!reuseIngredientError ? true : false;
  }

  checkEditingStatus(err: any) {
    if (err == 'editingStarted') {
      this.isRowEditable = true;
    } else if (err == 'editingStopped') {
      this.isRowEditable = false;
    }
  }

  inlineDataEditEvent(record: any) {
    if (record[2] === 'customReuse') {
      this.customService
        .GetPackageCostCalculationCustomReuse(record[1].amount, record[1].cost)
        .subscribe((data: any) => {
          this.customFacade.updateReuseIngredientAction(record[1], 'edit', record[3]);
        });
    }
  }

  onSave(reuseIngredientList: any) {
    this.submitted = true;
    this.processSubmitted = false;
    if (
      this.activatedRoute == 'adminCustomReuse' &&
      !this.customReuseForm.controls['organizationName'].value?.name &&
      !this.customReuseForm.controls['organizationName'].value
    ) {
      return;
    }
    if (this.customReuseForm.errors == null && this.customReuseForm.controls['reuseName'].valid) {
      //this.disableSubmit = false;
      const customReuseAddEditPayload = {
        id: this.customReuseId,
        processName: this.customReuseForm.controls['reuseName'].value.trimStart(),
        organizationId:
          this.customReuseForm.controls['organizationName'].value?.id ||
          this.customReuseData.organizationId ||
          this.cookieService.get('organizationId'),
        customReuseProcesses: reuseIngredientList,
      };
      this.saveCustomReuseEvent.emit({
        payload: customReuseAddEditPayload,
        pathName: this.activatedRoute,
      });
      this.submitted = false;
    }
  }

  ngOnDestroy() {
    this.customFacade.clearCustomReuseModal();
    this.customFacade.clearReuseIngredientProces();
  }
}
